import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ChatService, LoggerService } from '@adreno-common';
import { TimeCheckService, WorkService } from '../services';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-work',
  template: ` <router-outlet></router-outlet>`,
  styles: [
    `
      :host {
        display: flex;
        flex-grow: 1;
        overflow: auto;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkComponent implements OnInit {
  constructor(
    private workSvc: WorkService,
    private chatSvc: ChatService,
    private timeCheckSvc: TimeCheckService,
    private logger: LoggerService
  ) {}

  ngOnInit(): void {
    this.timeCheckSvc
      .checkTimeAndOffset()
      .pipe(
        tap((vm) => {
          if (vm.accepted) {
            this.logger.info('WorkComponent', 'checkTimeAndOffset', vm)();
            return;
          }
          this.logger.warn('WorkComponent', 'checkTimeAndOffset', vm)();
        })
      )
      .subscribe((vm) => {
        this.workSvc.setWork();
        this.chatSvc.loadChatDetails();
      });
  }
}
